meedy.controller('meedy.officeListController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceModel', 'meedy.availabilityRuleModel',
    'meedy.vacationModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel,
              resourceModel, availabilityRuleModel, vacationModel) {

        var listeners = {};

        function setData() {
            $scope.offices = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 100000;

            $scope.columns = [
                {
                    field: "name",
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.OFFICE_NAME')
                },
                {
                    field: "(firstName && lastName) ? firstName + ' ' +  lastName : '';",
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.PHYSICIAN')
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.ADDRESS'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-address.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.DELETE_OFFICE'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-delete-office.html',
                    width: 100
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.TIMESHEET'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-timesheet-actions.html',
                    width: 150
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.VACATION'),
                    cellTemplate: 'meedy/application/view/app/settings/office/grid-template/data-office-list-vacation-actions.html',
                    width: 100
                }
            ];

            $scope.currentState = Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST;
            $scope.Constant = Constant;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.RESOURCE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.offices = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
                availabilityRuleModel.getAvailabilityRules().then(listeners.onAvailabilityLoad);
            });

            $scope.$on(Event.MEEDY.RESOURCE.DELETE.SUCCESS, function(event, offices) {
                resourceModel.getDataPage($scope.criteria);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            listeners.onAvailabilityLoad = function (availabilityRulesWrapper) {
                $scope.availabilityRulesWrapper = availabilityRulesWrapper;
            }
        }

        function setActions() {

            $scope.createNewOffice = function() {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.CREATE);
            };

            $scope.editOffice = function(office) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.EDIT, {id : office.id});
            };

            $scope.deleteOffice = function(office) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.OFFICE.OFFICE_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    resourceModel.delete(office.id);
                }, function() {
                    return false;
                });
            };

            $scope.criteriaChanged = function() {
                resourceModel.getDataPage($scope.criteria);
            };

            $scope.findWrapperInAvailabilities = function(resource) {
                return _.find($scope.availabilityRulesWrapper, function (availability) {
                    return availability.resourceDTO.id === resource.id;
                });
            };

            $scope.editAvailabilityRule = function(resource) {
                var wrapper = $scope.findWrapperInAvailabilities(resource);
                var availabilityRuleIdToEdit = null;
                if(wrapper.currentAvailabilityRule) {
                    availabilityRuleIdToEdit = wrapper.currentAvailabilityRule.id;
                } else if(wrapper.futureAvailabilityRules && wrapper.futureAvailabilityRules.length) {
                    availabilityRuleIdToEdit = wrapper.futureAvailabilityRules[0].id;
                }

                if(availabilityRuleIdToEdit) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-edit-popup.html',
                        controller: 'meedy.popupAvailabilityEditController',
                        resolve: {
                            idAvailability: function() {
                                return availabilityRuleIdToEdit;
                            },
                            resource: function () {
                                return wrapper.resourceDTO;
                            }
                        }
                    }).then(function() {
                        resourceModel.getDataPage($scope.criteria);
                    }, function(error){

                    })
                } else {
                    $scope.alert($translate.instant('T.MEEDY.MODULE.OFFICE.NO_AVAILABILITY_RULE_ID_ALERT_FOR_USER'), null, $translate.instant('T.MEEDY.UI.APPLICATION.OK'))
                }
            };

            $scope.createNewAvailability = function(resource) {
                var wrapper = $scope.findWrapperInAvailabilities(resource);

                if(wrapper.futureAvailabilityRules.length > 0 && wrapper.currentAvailabilityRule) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/popup/popup-alert.html',
                        controller: 'meedy.popupAlertController',
                        resolve: {
                            message: function () {
                                return 'T.MEEDY.MODULE.AVAILABILITY.CANNOT_ADD_MORE_AVAILABILITY';
                            },
                            title: function() {
                                return 'T.DATA.ALERT';
                            }
                        }
                    })
                } else {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-create-popup.html',
                        controller: 'meedy.popupAvailabilityCreateController',
                        resolve: {
                            resource: function () {
                                return objectHelper.translateObject(wrapper.resourceDTO, ResourceMeedyVO);
                            }
                        }
                    }).then(function () {
                        resourceModel.getDataPage($scope.criteria);
                    }, function (error) {

                    });
                }
            };

            $scope.deleteAvailabilityRule = function(resource) {
                var availabilityRule = $scope.findWrapperInAvailabilities(resource).currentAvailabilityRule;
                var futureAvailabilityRule = $scope.findWrapperInAvailabilities(resource).futureAvailabilityRules;

                if(!availabilityRule && futureAvailabilityRule.length === 1) {
                    availabilityRule = futureAvailabilityRule[0];
                }

                if(!availabilityRule && futureAvailabilityRule.length > 1) {
                    var alert = $mdDialog.alert({
                        title: $translate.instant("T.MEEDY.MODULE.AVAILABILITY.CANNOT_DELETE_AVAILABILITY_RULE_PLEASE_CONTACT_CONSULTANT"),
                        ok: $translate.instant('T.MEEDY.UI.APPLICATION.OK')
                    });
                    $mdDialog.show(alert);
                }

                if(availabilityRule) {
                    var confirm = $mdDialog.confirm({
                        title: $translate.instant('T.MEEDY.MODULE.AVAILABILITY.AVAILABILITY_DELETE_CONFIRMATION'),
                        ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                        cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                    });
                    $mdDialog.show(confirm).then(function() {
                        availabilityRuleModel.deleteAvailabilityRule(availabilityRule).then(function () {
                            resourceModel.getDataPage($scope.criteria);
                        })
                    }, function() {
                        return false;
                    });
                }
            };

            $scope.createVacation = function(resource) {
                vacationModel.getVacationForResource(resource.id).then(function (vacation) {
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/settings/availability/popup/vacation-create-popup.html',
                        controller: 'meedy.popupVacationCreateController'
                    }).then(function(editedVacation) {
                        editedVacation.resource = resource;
                        vacationModel.createVacationForOffice(editedVacation).then(function() {
                            resourceModel.getDataPage($scope.criteria);
                        })
                    }, function(error){

                    })
                })
            };

            $scope.deleteVacation = function(resource) {
                vacationModel.getVacationForResource(resource.id).then(function (vacation) {
                    var confirm = $mdDialog.confirm({
                        title: $translate.instant('T.MEEDY.MODULE.AVAILABILITY.VACATION_DELETE_CONFIRMATION'),
                        ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                        cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                    });
                    $mdDialog.show(confirm).then(function() {
                        vacationModel.deleteVacationForOffice(vacation[0]).then(function() {
                            resourceModel.getDataPage($scope.criteria);
                        })
                    }, function() {
                        return false;
                    });
                })
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            resourceModel.getDataPage($scope.criteria);
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;
            $scope.showAddButton($scope.createNewOffice);
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
